module.exports = __webpack_public_path__ + "fonts/Lato-700-latin8.de69cf9.woff2";